import { TopBarNavComponent } from './top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
/**
 * Compatibility shell: TopBarNavComponent is standalone, this module only re exports it for
 * the NgModule based page apps. Import the component directly in standalone contexts.
 */
export class NavigationModule {
}
NavigationModule.ɵfac = function NavigationModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NavigationModule)(); };
NavigationModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NavigationModule });
NavigationModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [TopBarNavComponent] });
